function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 0H32V31.9927H0V0Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_68:2549)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.1732 10.0573L16.1678 7.99362L19.1147 6.7407L24.086 8.96489L21.1732 10.0573ZM14.978 12.3799L1.65364 6.67029L14.978 0.961754L30.2077 6.67029L25.3255 8.501L19.3001 5.80257C19.1675 5.74355 19.0215 5.74976 18.8973 5.81706L14.7854 7.567C14.6146 7.63949 14.5007 7.81345 14.5007 8.0019C14.5007 8.19036 14.6136 8.35914 14.7886 8.43162L19.8955 10.5398L14.978 12.3799ZM21.6454 17.1389V10.8753L24.8554 9.67107V15.9346L21.6454 17.1389ZM14.5007 30.8133L0.936063 25.0012V7.37855L14.5007 13.1906V30.8133ZM15.4326 30.8485V13.2051L20.7135 11.2253V17.8119C20.7135 17.9641 20.7891 18.107 20.9154 18.195C21.0355 18.2779 21.1898 18.3038 21.3482 18.2458L25.486 16.6947C25.6661 16.6273 25.7873 16.4513 25.7873 16.2587V9.32109L31.0682 7.34127V24.9846L15.4326 30.8485ZM0.00517734 6.55742C0.0134611 6.55742 0.00414187 6.61334 0.00414187 6.66822V25.3087C0.00414187 25.4961 0.114937 25.6639 0.286825 25.7395L14.7834 31.9512C14.8942 31.9968 15.0164 32.0009 15.1313 31.9575L31.6988 25.7446C31.88 25.6773 32.0001 25.5023 32.0001 25.3087L31.9949 6.7231C31.9794 6.63715 31.9742 6.57399 31.969 6.52015L31.8934 6.40107C31.8334 6.31927 31.7723 6.2706 31.7071 6.24471L15.6376 0.0370808C15.4647 -0.0126216 14.7409 -0.0146926 14.5608 0.0370808L0.251619 6.26956C0.219519 6.28509 0.16671 6.33066 0.118043 6.39485L0 6.56053C0.00207094 6.55846 0.00414187 6.55742 0.00517734 6.55742Z",
  fill: "#333333"
}));

var SvgOrderItemsIcon = function SvgOrderItemsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_68:2549",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _ref2), _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOrderItemsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Order_items_icon.3d16cfd7.svg";
export { ForwardRef as ReactComponent };